import React from 'react'
import { StatCards, type StatItem } from '@/shared/ui'
import type { RewardsMasterMetric } from '../../utils/rewardsMasterChart'

export type RewardsMasterKpiItem = {
  metric: RewardsMasterMetric
  label: string
  value: React.ReactNode
  tone?: StatItem['tone']
}

export default function RewardsMasterKpiCards({
  items,
  activeMetric,
  onSelect,
}: {
  items: RewardsMasterKpiItem[]
  activeMetric: RewardsMasterMetric
  onSelect: (metric: RewardsMasterMetric) => void
}) {
  const cards: StatItem[] = items.map((it) => ({
    label: it.label,
    value: it.value,
    tone: it.tone,
    active: it.metric === activeMetric,
    onClick: () => onSelect(it.metric),
  }))

  return <StatCards items={cards} className="sm:grid-cols-1 lg:grid-cols-1" />
}
